function replaceVideo(event) {
    var video = this.getElementsByTagName("iframe")[0];
    video.setAttribute("src", video.getAttribute("data-source"));
    video.classList.add("h-full", "w-full");
    video.classList.remove("h-1", "w-1", "hidden");
}
document
    .querySelectorAll(".replace-video")
    .forEach((element) =>
        element.addEventListener("click", replaceVideo, { once: true })
    );
